export default __webpack_public_path__ + "universal/images/noblehour.df1dccaa8d746a07be17b98cefcd4cf9.svg";